import { createFileRoute } from '@tanstack/react-router';
import {
  loadSystemApplicationMessages,
  loadSystemApplicationScreens,
  systemApplicationListScreen,
  systemApplicationListSearch,
} from '@/modules/system-application/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/seguranca/usuarios-aplicacao/')({
  validateSearch: systemApplicationListSearch,
  staticData: { screen: systemApplicationListScreen },
  loader: () => loadSystemApplicationMessages(),
  component: lazyScreen(loadSystemApplicationScreens, 'SystemApplicationListScreen'),
});
